'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lang = require('lodash/lang');

var _redux = require('redux');

var _Constants = require('../actions/Constants');

var Constants = _interopRequireWildcard(_Constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Handles the ID of the application.
 * @param {String} state - Current ID.
 * @param {FSA} action - The dispatched action.
 * @returns {String} The new ID.
 */
var id = function id() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case Constants.APP_SUBMIT_FAILED:
      window.scrollTo(0, 0);
      return state;
    case Constants.POST_CREATE_APP_COMPLETE:
      return !action.error ? action.payload.data.id : state;
    default:
      return state;
  }
};

/**
 * Handles the quote data for the application.
 * @param {Object} state - Current quote information.
 * @param {FSA} action - The dispatched action.
 * @returns {Object} - New quote information.
 */
var quote = function quote(state, action) {
  if ((0, _lang.isUndefined)(state)) {
    return {
      price: null,
      information: null,
      content: [],
      links: []
    };
  }

  switch (action.type) {
    case Constants.GET_APP_QUOTE_COMPLETE:
      return !action.error ? {
        price: action.payload.data.quote.price,
        information: null,
        content: action.payload.data.content,
        links: action.payload.data.links,
        updatePremiumOnChange: true
      } : state;
    case Constants.GET_MSH_QUOTE_COMPLETE:
      return !action.error ? {
        price: action.payload.data.data.premium,
        underwriting: action.payload.data.data.underwriting,
        questionnaire: action.payload.data.data.questionnaire,
        reference: action.payload.data.data.reference,
        information: null,
        content: [],
        links: [],
        updatePremiumOnChange: true
      } : state;
    case Constants.RESET_MSH_QUOTE:
      return {
        price: null,
        information: action.payload.data.messages,
        content: [],
        links: [],
        updatePremiumOnChange: true
      };
    default:
      return state;
  }
};

var eligibility = function eligibility(state, action) {
  if ((0, _lang.isUndefined)(state)) {
    return {
      eligibility: null,
      information: null,
      content: [],
      links: []
    };
  }

  switch (action.type) {
    case Constants.GET_ELIGIBILITY_COMPLETE:
      return !action.error ? {
        eligibility: true,
        information: null
      } : state;
    case Constants.GET_ELIGIBILITY_ERROR:
      return {
        eligibility: null,
        information: action.payload.data.messages,
        content: [],
        links: []
      };
    default:
      return state;
  }
};

var questionnaire = function questionnaire(state, action) {
  if ((0, _lang.isUndefined)(state)) {
    return {
      questionnaire: null
    };
  }

  switch (action.type) {
    case Constants.GET_QUESTIONNAIRE_DATA:
      return {
        result: action.payload,
        applicantInfo: true,
        information: null
      };
    case Constants.SUBMIT_QUESTIONNAIRE_DATA:
      return {
        result: action.payload,
        information: null,
        complete: true
      };
    case Constants.ERROR_QUESTIONNAIRE_DATA:
      return {
        result: action.payload,
        information: action.payload.messages,
        complete: true
      };
    default:
      return state;
  }
};

exports.default = (0, _redux.combineReducers)({
  id: id,
  quote: quote,
  eligibility: eligibility,
  questionnaire: questionnaire
});


//////////////////
// WEBPACK FOOTER
// ./src/v2/reducers/msh.js
// module id = 1731
// module chunks = 0